<template>
  <div class="nv-grid-row nv-grid-multiline">
    <div class="nv-grid-col nv-px-0 nv-grid-col-12">
      <h4>
        {{ $t('recent_activity') }}
      </h4>
    </div>
    <div class="nv-grid-col nv-px-0 nv-grid-col-12">
      <ul class="articles-list nv-d-grid">
        <nuxt-link
          v-for="(article, idx) of data?.docs"
          :key="idx"
          :to="localePath(`/support/kb/${article.slug}`)"
        >
          <li

            class="article-item"
          >
            <div class="nv-d-flex nv-flex-column">
              <h6>{{ article.title }}</h6>
              <span>
                {{ article.description }}
              </span>
              <!--  -->
            </div>
          </li>
        </nuxt-link>
      </ul>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { IPayloadCMSSupportArticles } from '~/server/api/support/[region]/types';
import { useProductStore } from '~/store/product';

// ---------------------------------------
// Hooks
// ---------------------------------------
const { $cms } = useNuxtApp();
const { t, locale } = useI18n();
const localePath = useLocalePath();
const productStore = useProductStore();

const { product } = storeToRefs(productStore);

// -----------------------------------
// Hooks
// -----------------------------------
const { localeProperties } = useI18n();
const {status, error, data } = await useFetch<IPayloadCMSSupportArticles>(`/api/support/${localeProperties.value.region}/articles?language_code=en&limit=12&product_id=${product.value?.id}&sort=-createdAt`,
  {
    key: `productsGridSupport:${localeProperties.value.code}:${localeProperties.value.language}:${product.value?.id}`,
    lazy: true,
    immediate: true,
  }
);

</script>

<style lang="scss" scoped>
/*
* Mixes
*/
@import '@nuiverse/core/src/style/_utils';
@import '@nuiverse/core/src/style/mixins/_breakpoints';

.articles-list {
  color: inherit;
  list-style: none;

  a {
    color: inherit;
  }
}

.articles-list {
  column-gap: 24px;
  grid-template-columns: repeat(auto-fill, minmax(450px, 1fr));
  row-gap: 24px;

  li {
    background: var(--nv-theme);
    border-radius: 8px;
    color: initial;
    height: 100%;
    padding: 24px;

    span {
      -webkit-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      overflow: hidden;
    }

    &:hover {
      box-shadow: 0 0 4px 4px rgba(0, 99, 180, 0.12);
      cursor: pointer;
    }

    img {
      height: 24px;
      margin-right: 8px;
      width: 24px;
    }
  }
}

</style>
